






















import Vue from 'vue';
import LanguageDesignationUtils, {
  LanguageDesignation,
} from '@/utils/LanguageDesignationUtils';
import { locales } from '@/i18n';

export default Vue.extend({
  computed: {
    table() {
      return {
        items: this.items,
        headers: [
          {
            text: this.$i18n.tc('languageDesignation.key'),
            value: 'key',
          },
          {
            text: this.$i18n.tc('languageDesignation.province'),
            value: 'province.name',
          },
          {
            text: this.$i18n.tc('languageDesignation.name'),
            value: 'name',
          },
          {
            text: '',
            value: 'actions',
          },
        ],
      };
    },

    locales() {
      return locales;
    },
  },

  data: (): {
    items?: LanguageDesignation[];
  } => ({
    items: undefined,
  }),

  async mounted() {
    try {
      this.items =
        await LanguageDesignationUtils.languageDesignation.api.list();
    } catch (error) {
      console.error(error);
    } finally {
      //
    }
  },

  methods: {
    async handleEdit(item: LanguageDesignation) {
      await this.$router.push({
        name: 'languageDesignation-edit',
        params: { id: item.id.toString() },
      });
    },

    async handleCreate() {
      await this.$router.push({
        name: 'languageDesignation-create',
      });
    },
  },
});
